import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, Phone, MapPin, ArrowUp } from 'lucide-react';
import { scrollToTop } from '../lib/utils';
import { ChristianIcon } from './ChristianElements';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const footerLinks = [
    { key: 'story', path: '/story' },
    { key: 'craft', path: '/craft' },
    { key: 'materials', path: '/materials' },
    //{ key: 'faq', path: '/faq' },
   // { key: 'contact', path: '/contact' },
    { key: 'legal', path: '/legal' },
   // { key: 'wholesale', path: '/wholesale' },
  ];

  return (
    <footer className="bg-primary-800 text-white holy-land-bg">
      <div className="container-max section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 rtl:space-x-reverse mb-4">
              <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center relative">
                <span className="text-primary-600 font-bold text-sm">HL</span>
                <div className="absolute -top-1 -right-1">
                  <ChristianIcon icon="cross" size="sm" className="text-gold-500" />
                </div>
              </div>
              <span className="font-scripture text-xl font-semibold">
                Holy Land Coffins
              </span>
            </div>
            <p className="text-primary-100 mb-6 max-w-md">
              {t('footer.disclaimer')}
            </p>
            
            {/* Christian blessing 
            <div className="mb-6">
              <ScriptureQuote 
                verse={t('scriptures.hope.verse')}
                reference={t('scriptures.hope.reference')}
                className="bg-white/10 backdrop-blur-sm border-gold-400/50 text-white text-sm"
              />
            </div>*/}
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 rtl:space-x-reverse">
                <MapPin className="w-5 h-5 text-primary-300" />
                <span className="text-primary-100">{t('footer.address')}</span>
              </div>
              <div className="flex items-center space-x-3 rtl:space-x-reverse">
                <Phone className="w-5 h-5 text-primary-300" />
                <span className="text-primary-100">{t('footer.phone')}</span>
              </div>
              <div className="flex items-center space-x-3 rtl:space-x-reverse">
                <Mail className="w-5 h-5 text-primary-300" />
                <span className="text-primary-100">{t('footer.email')}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif text-lg font-semibold mb-4">
              {t('nav.home')}
            </h3>
            <ul className="space-y-2">
              {footerLinks.slice(0, 5).map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.path}
                    className="text-primary-100 hover:text-white transition-colors duration-200"
                  >
                    {t(`nav.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Additional Links */}
          <div>
            {/* <h3 className="font-serif text-lg font-semibold mb-4">
              {t('footer.contact')}
            </h3> */}
            <ul className="space-y-2">
              {footerLinks.slice(5).map((link) => (
                <li key={link.key}>
                  <Link
                    to={link.path}
                    className="text-primary-100 hover:text-white transition-colors duration-200"
                  >
                    {t(`nav.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-primary-200 text-sm">
            {t('footer.copyright')}
          </p>
          
          <button
            onClick={scrollToTop}
            className="flex items-center space-x-2 rtl:space-x-reverse text-primary-200 hover:text-white transition-colors duration-200 mt-4 md:mt-0"
          >
            <ArrowUp className="w-4 h-4" />
            <span className="text-sm">{t('common.backToTop')}</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
